let isSubscribe=false;
if((new URLSearchParams(window.location.search)).get('customer_posted')){
    isSubscribe=true;
}else{
    isSubscribe=false;
}
let driversDownloadInfo={};
let driversDownloadUrl='';
let driversSystem='';
document.addEventListener('DOMContentLoaded', function() {
    document.getElementById("Recipient-Checkbox")?document.getElementById("Recipient-Checkbox").addEventListener('change', function() {
        if (this.checked) {
            document.getElementById("DirversSubscribeSubmitBtn").type = "submit";
            document.getElementById("DirversSubscribeSubmitBtn").removeEventListener('click',downloadUrlLink)
        }else{
            document.getElementById("DirversSubscribeSubmitBtn").type = "button";
            document.getElementById("DirversSubscribeSubmitBtn").addEventListener('click',downloadUrlLink)
        }
    }):'';
  
    document.getElementById('DirversSubscribeForm').addEventListener('submit', function(event) {
        downloadUrlLink()
    })
})

function ToggleSubscribePopup(type,data,system){
    driversDownloadInfo=data?data:driversDownloadInfo;
    driversDownloadInfo.name=window.modleName;
    driversDownloadUrl=data?data.url:driversDownloadUrl;
    driversSystem=system?system:driversSystem;
    document.getElementById("signup-tags")?document.getElementById("signup-tags").value=driversDownloadInfo.name?"drivers_newsletter_"+driversDownloadInfo.name:"drivers_newsletter":"";
    document.getElementById("dirvers_subscribe_popup_content")?document.getElementById("dirvers_subscribe_popup_content").innerHTML =
    `<p>Machine Model：<span style="color:#bf1721">${driversDownloadInfo.name}</span>
    <br/>Operating System：<span style="color:#bf1721">${system}</span></p>
    <p style="display:none;">${driversDownloadUrl}</p>`:'';
    
     
    if(isSubscribe){
       
        window.open(driversDownloadUrl);
        return
    }
    document.getElementById("dirvers-subscribe-popup-section").style.display = type?"flex":"none";
}
function downloadUrlLink(){
    ToggleSubscribePopup(false);
    if(sensorsClickEvent){
        sensorsClickEvent(
            {
                event_code:'drivers-download', 
                models:driversDownloadInfo.name,
                system:driversSystem,
                isSubscribe:document.getElementById("Recipient-Checkbox").checked
            }
        )
    }
    if(driversDownloadUrl){
    window.open(driversDownloadUrl);
    }
}

function createAccountLink(){
    if(VipApp.config.isLogin){
        window.location.href=VipApp.config.vip_account_url+'?type=5';
    }else{
         window.location.href='https://phomemo.com/account/login?return_to=/pages/a-letter-to-phomemo-customers';
    }
}
